import React from "react";
import { Modal, Button } from "react-bootstrap";
import "../styles.css";
import {
    AppElevvaIcon,
    BodyCompositionIcon,
    ClassBookingIcon,
    DashboardCorporateIcon,
    GamificationIcon,
    PhysicalTestsIcon,
    ReservationsIcon,
    RetentionMetricsIcon,
    StorageIcon,
    TrainingProgramIcon,
    UserDashboardIcon,
    UsersIcon
} from "./icons/icons";

const FEATURES = [
    {
        icon: UsersIcon,
        text: "3 usuarios administrativos incluidos",
    },
    {
        icon: DashboardCorporateIcon,
        text: "Dashboard corporativo",
    },
    {
        icon: ReservationsIcon,
        text: "Gestión de reservas y entrenamientos",
    },
    {
        icon: AppElevvaIcon,
        text: "App Elevva para tus clientes",
    },
    {
        icon: StorageIcon,
        text: "Almacenamiento de documentos",
    },
    {
        icon: ClassBookingIcon,
        text: "Reserva de clase",
    },
    {
        icon: BodyCompositionIcon,
        text: "Medición de Composición Corporal",
    },
    {
        icon: PhysicalTestsIcon,
        text: "Pruebas Físicas Personalizadas",
    },
    {
        icon: UserDashboardIcon,
        text: "Dashboard Interactivo para Usuarios",
    },
    {
        icon: RetentionMetricsIcon,
        text: "Métricas de Retención",
    },
    {
        icon: GamificationIcon,
        text: "Gamificación y Retos SMART",
    },
    {
        icon: TrainingProgramIcon,
        text: "Programación de entrenamiento",
    },
];


const WelcomeModal = ({ show, onStartTrial, onSkipTrial }) => {
    const firstRow = FEATURES.slice(0, 6);
    const secondRow = FEATURES.slice(6, 12);

    return (
        <Modal
            show={show}
            size="lg"
            centered
            className="welcome-modal"
        >
            <Modal.Body className="p-0 welcome-modal-bg">

                <div className="welcome-modal-container">

                    <div className="welcome-modal-right d-flex flex-column align-items-center gap-4 p-5">

                        <div className="welcome-modal-title text-center d-flex flex-column align-items-center">
                            Gestiona tu gimnasio
                            <label>sin límites.</label>
                        </div>

                        <div className="welcome-modal-subtitle text-center d-flex flex-column align-items-center">
                            La plataforma todo en uno para centros deportivos.
                            <label>Automatiza reservas, pagos y retención de clientes en minutos.</label>
                        </div>

                        <div className="welcome-modal-buttons text-center d-flex flex-row align-items-center gap-2">
                            <Button className="welcome-modal-button" onClick={onStartTrial}>
                                Iniciar prueba de 30 días <svg xmlns="http://www.w3.org/2000/svg" width="12" height="10" viewBox="0 0 12 10" fill="none">
                                    <path d="M6.27454 0.632812L10.837 4.98791M10.837 4.98791L6.27454 9.34301M10.837 4.98791H0.634369" stroke="white" stroke-width="1.26872" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </Button>
                            <Button className="welcome-modal-button-skip" onClick={onSkipTrial}>
                                Saltar prueba y comprar
                            </Button>
                        </div>

                        <div className="welcome-modal-features">
                            <div className="welcome-modal-row">
                                {firstRow.map(({ icon: Icon, text }, i) => (
                                    <div key={i} className="welcome-modal-feature">
                                        <div className="welcome-modal-feature-icon">
                                            <Icon />
                                        </div>
                                        <span className="welcome-modal-feature-text">{text}</span>
                                    </div>
                                ))}
                            </div>

                            <div className="welcome-modal-row">
                                {secondRow.map(({ icon: Icon, text }, i) => (
                                    <div key={i} className="welcome-modal-feature">
                                        <div className="welcome-modal-feature-icon">
                                            <Icon />
                                        </div>
                                        <span className="welcome-modal-feature-text">{text}</span>
                                    </div>
                                ))}
                            </div>
                        </div>

                    </div>
                </div>

            </Modal.Body>
        </Modal>
    );
};

export default WelcomeModal;
